import { render, staticRenderFns } from "./card-grid-social.vue?vue&type=template&id=0dedec76"
import script from "./card-grid-social.vue?vue&type=script&lang=js"
export * from "./card-grid-social.vue?vue&type=script&lang=js"
import style0 from "./card-grid-social.vue?vue&type=style&index=0&id=0dedec76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports